import type { FileInfo, FileTag } from '../../lib/types';

export const replaceFilesByTag = (
  currentFiles: FileInfo[],
  tag: FileTag,
  replacementFiles: FileInfo[]
): FileInfo[] => [
  ...currentFiles.filter((file) => file.tag !== tag),
  ...replacementFiles,
];
